import styled from "styled-components";

export const Container = styled.div`
  align-items: center;
  flex-direction: column;
  display: flex;
  width: 100%;
  align-items: center;
  flex-direction: column;
  display: flex;
  width: 100%;
`;
export const Title = styled.h1`
  font-family: ${(props) => props.theme.fonts.aeonik};
  font-weight: 500;
  font-size: 30px;
  line-height: 40px;
  font-style: normal;
  width: 100%;
  text-align: center;
`;
export const Description = styled.div`
  display: block;
  font-family: ${(props) => props.theme.fonts.aeonik};
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: -0.15px;
  margin: 1rem 0;
  width: 100%;
  text-align: center;
  color: ${(props) => props.color || props.theme.colors.neutrals.primary.white};
  & a {
    color: ${(props) => props.theme.colors.green[300].accent};
    cursor: pointer;
    font-weight: 700;
  }
`;
